import { useState } from "react";

import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import Form from "react-bootstrap/Form";
import { useSelector } from "react-redux";

import LinkedinLeadSource from "components/organisms/CRMs/LinkedinLeadSource";

import { isArrayControl } from "./leadSourceSection.helpers";

/**
 * LinkedIn lead-source connect flow for LeadsStep1: pick an existing LinkedIn
 * lead source or log in through LinkedinLeadSource. Login state is only used
 * to hide the exist-select once logged in, so it lives here; everything that
 * feeds toNext() stays lifted in LeadsStep1.
 */
const LinkedinLeadSourceSection = ({
    sourceConnectedList,
    selectedConnectedSourceApiId,
    isLoadingConnectedSources,
    connectedSourceChange,
    resetConnectedSourceSelection,
    setNextButtonDisabled,
    selectedLinkedinSource,
    setLinkedinData,
    shouldLoadLinkedinForms,
    setShouldLoadLinkedinForms,
}) => {
    const [isLinkedinLoggedIn, setIsLinkedinLoggedIn] = useState(false);

    return (
        <>
            {!selectedConnectedSourceApiId &&
                !isLoadingConnectedSources &&
                !isLinkedinLoggedIn &&
                isArrayControl(sourceConnectedList) && (
                    <Form.Group
                        className="mb-2"
                        controlId="exampleForm.ControlInput1"
                    >
                        <FormControl
                            style={{
                                width: "100%",
                            }}
                            className="tour-facebook-exist-select"
                        >
                            <Select
                                id="id"
                                label={"Select Linkedin Lead"}
                                onChange={(event) => {
                                    connectedSourceChange(
                                        event.target.value,
                                        sourceConnectedList.find(
                                            (x) => x?.id === event.target.value,
                                        ),
                                    );
                                    setNextButtonDisabled(false);
                                }}
                                value={selectedConnectedSourceApiId}
                            >
                                {sourceConnectedList &&
                                    sourceConnectedList.map((item) => (
                                        <MenuItem key={item.id} value={item.id}>
                                            {item.name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </Form.Group>
                )}
            {isArrayControl(sourceConnectedList) &&
                !selectedConnectedSourceApiId &&
                !isLinkedinLoggedIn && (
                    <div className="wizard-or-area mt-2 mb-2">
                        Or Create New LinkedIn Lead Source
                    </div>
                )}
            <LinkedinLeadSource
                setLinkedinData={setLinkedinData}
                selectedLinkedinSource={selectedLinkedinSource}
                shouldLoadLinkedinForms={shouldLoadLinkedinForms}
                setShouldLoadLinkedinForms={setShouldLoadLinkedinForms}
                setIsLoggedIn={setIsLinkedinLoggedIn}
                selectedConnectedSourceApiId={selectedConnectedSourceApiId}
                resetConnectedSourceSelection={resetConnectedSourceSelection}
            />
        </>
    );
};

export default LinkedinLeadSourceSection;
